import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IGetCompanyJobsResponseData,
  IGetCompanyJobsArgs,
} from "./getCompanyJobs.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IGetCompanyJobsResponseData>;

export const getCompanyJobs = (axios: IAxiosInstance) => {
  return async (params: IGetCompanyJobsArgs) => {
    try {
      const response = await axios.noRetry.get<SuccessResponse>(
        `/api/company-jobs`,
        {
          params,
        }
      );

      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
